import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    public httpClient: HttpClient
  ) { }


  get(endpoint: string): any {
    return this.httpClient.get<any>(`${environment.apiUrl}/${endpoint}`);
  }

  post(endpoint: string, data: any): any {
    return this.httpClient.post<any>(`${environment.apiUrl}/${endpoint}`, data);
  }
}
